import { ComponentFields, Field, ImageField, Item } from '@sitecore-jss/sitecore-jss-nextjs';

import { LearningTypes } from 'src/enums/LearningTypes';

import { ContentDetailItem } from 'src/types/ContentDetailsItem';
import { ExtendedItem } from 'src/types/ExtendedItem';
import { ResourceListItem } from 'src/types/ResourceListItem';

import { parseAccessLevelRouteFields } from '../fields/parseAccessLevelContent';
import { parseAccessTypes, parseAccessTypesString } from '../fields/parseAccessTypes';
import { parseIsoDate } from '../fields/parseDate';
import { parseTags } from '../fields/parseTags';
import { parseTypesOfResources, parseTypesOfResourcesString } from '../fields/parseTypesOfResources';
import { parseWildCardUrl } from '../fields/parseUrl';

export function mapClinicalTopic(item: ExtendedItem, wildcardUrl?: string): ResourceListItem | null {
	try {
		if (!item) {
			return null;
		}

		return {
			Id: item.id,
			Title: (item.fields.Title as Field<string>).value,
			Strapline: (item.fields.Strapline as Field<string>)?.value,
			Url: parseWildCardUrl(item.name, wildcardUrl),
			LearningType: LearningTypes.Resource.toString(),
			AccessTypes: parseAccessTypes(item.fields.AccessType),
			AccessTypesString: parseAccessTypesString(item.fields.AccessType),
			TypesOfResources: parseTypesOfResources(item.fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(item.fields.Tags),
			ImageUrl: item.fields['Background Image'] ? (item.fields['Background Image'] as ImageField).value?.src : '',
			Tags: parseTags(item.fields.Tags),
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}

export function mapClinicalTopicToContentDetails(
	id: string,
	fields: ComponentFields | undefined,
	wildcardContentUrl: string
): ContentDetailItem | null {
	try {
		if (!fields) {
			return null;
		}

		const dateUpdated = fields.DateUpdated ? parseIsoDate((fields.DateUpdated as Field<string>).value) : null;

		const professionalLeadItem = fields['Professional Lead'] as Item;

		return {
			Id: id,
			Title: (fields.Title as Field<string>)?.value,
			Strapline: (fields.Strapline as Field<string>)?.value,
			ImageUrl: fields['Background Image'] ? (fields['Background Image'] as ImageField).value?.src : '',
			Tags: parseTags(fields.Tags),
			AccessTypes: parseAccessTypes(fields.AccessType),
			AccessTypesString: parseAccessTypesString(fields.AccessType),
			Access: parseAccessLevelRouteFields(fields),
			TypesOfResources: parseTypesOfResources(fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(fields.Tags),
			DateUpdated: dateUpdated,
			Information: (fields.Information as Field<string>)?.value,
			PeerReviewed: fields.PeerReviewed && (fields.PeerReviewed as Field<boolean>).value === true,
			LearningTypeString: LearningTypes.Resource.toString(),
			LearningType: LearningTypes.Resource,
			CertificateOfCompletion: false,
			ProfessionalLeads: professionalLeadItem
				? {
						FirstName: professionalLeadItem.fields.FirstName ? (professionalLeadItem.fields.FirstName as Field<string>)?.value : undefined,
						LastName: professionalLeadItem.fields.LastName ? (professionalLeadItem.fields.LastName as Field<string>)?.value : undefined,
						Email: professionalLeadItem.fields.EmailAddress
							? (professionalLeadItem.fields.EmailAddress as Field<string>)?.value
							: undefined,
				  }
				: undefined,
			Url: wildcardContentUrl,
			Cost: (fields.Cost as Field<string>)?.value,
			Location: (fields.Location as Field<string>)?.value,
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}
